module.exports = __webpack_public_path__ + "static/twinMotion2-022f8425f22d4241898ebc335e811c1b.png";